import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Report } from "../Interfaces/TableInterfaces";
import { IConversionSearchParam } from "../Interfaces/conversion";
import { IConversionReport } from "../Interfaces/deltaHedgeExe";
import { getTable } from "./requestTemplates";
import { AxiosRequestConfig } from "axios";

export const getConversionTable = (
  searchParam: IConversionSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IConversionReport>> =>
  getTable<IConversionSearchParam, IConversionReport>(
    "/v1/OptionConversion/Table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );
